import API from "@utils/request";
import { PAGE_SIZE } from "@config";
import store from "../store";
const ADRESS = "/api/website/";

/**
* 获取站点表列表（分页）
* @author 四川创企
* @DateTime 2024/05/22
* @param {object} params
* @param {object} pages
*/
export async function getWebsiteList(params, pages) {
    try {
        return await API.get(ADRESS + "list", {
            params: {
            ...params,
            ...pages,
            },
            headers: { isLoading: true },
        });
    } catch (error) {
        return error;
    }
}

  /**
  * 获取站点表详情
  * @author 四川创企
  * @DateTime 2024/05/22
  * @param {number} id
  */
  export async function getWebsiteInfo(id) {
  try {
  return await API.post(ADRESS + "info", {
  id:id,
  });
  } catch (error) {
  return error;
  }
  }
  /**
  * 编辑站点表
  * @author 四川创企
  * @DateTime 2024/05/22
  * @param {object} params
  */
  export async function editWebsite(params) {
  try {
  return await API.post(ADRESS + "edit", params);
  } catch (error) {
  return error;
  }
  }

  /**
  * 新增站点表
  * @author 四川创企
  * @DateTime 2024/05/22
  * @param {object} params
  */
  export async function addWebsite(params) {
  try {
  return await API.post(ADRESS + "add", params);
  } catch (error) {
  return error;
  }
  }
  /**
  * 刪除站点表
  * @author 四川创企
  * @DateTime 2024/05/22
  * @param {number} id
  */
  export async function deleteWebsite(id) {
  try {
  return await API.post(ADRESS + "delete", {
  id: {
  id,
  },
  });
  } catch (error) {
  return error;
  }
  }
                                                        /**
  * 修改单个字段值
  * @author 四川创企
  * @DateTime 2024/05/22
  * @param {number} id
  */
  export async function updateWebsiteField(id, field, value) {
  try {
  return await API.post(ADRESS + "updatefield", {
  id: id,
  field: field,
  value: value,
  });
  } catch (error) {
  return error;
  }
  }
  /**
  * 获取站点表键值对
  * @author 四川创企
  * @DateTime 2024/05/22
  * @param {object} key
  * @param {object} value
  */
  export async function getWebsiteKeyVal(key, value,params={}) {
  try {
  return await API.post(ADRESS + "getkeyval", {
  key: key,
  value: value,
  params:params
  });
  } catch (error) {
  return error;
  }
  }


